export default {
  ...BUILD_CONFIG,
  userStorageKey: 'conreign.user',
};
